// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__STegJ","index":"styles_index__3BAAs"};